/**
 * Transform pricing from raw response for PE model
 *
 */
var getModelPePricing = function (financials, trim, hasError) {
    var _a, _b, _c, _d, _e;
    var financialsTrim = (_c = (_b = (_a = financials === null || financials === void 0 ? void 0 : financials.models) === null || _a === void 0 ? void 0 : _a.find(function (m) { return (m === null || m === void 0 ? void 0 : m.modelKey) === (trim === null || trim === void 0 ? void 0 : trim.modelKey); })) === null || _b === void 0 ? void 0 : _b.trims) === null || _c === void 0 ? void 0 : _c.find(function (t) { return (t === null || t === void 0 ? void 0 : t.key) === (trim === null || trim === void 0 ? void 0 : trim.trimKey); });
    var financialsTransmission = financialsTrim ? (_d = financialsTrim === null || financialsTrim === void 0 ? void 0 : financialsTrim.transmissions) === null || _d === void 0 ? void 0 : _d[0] : {};
    var exteriorColor = (_e = financialsTransmission === null || financialsTransmission === void 0 ? void 0 : financialsTransmission.exteriorColors) === null || _e === void 0 ? void 0 : _e[0];
    if (!exteriorColor)
        return null;
    return {
        msrp: exteriorColor === null || exteriorColor === void 0 ? void 0 : exteriorColor.msrp,
        sellingPrice: exteriorColor === null || exteriorColor === void 0 ? void 0 : exteriorColor.sellingPrice,
        freightPdiCost: financialsTrim === null || financialsTrim === void 0 ? void 0 : financialsTrim.freightPdiCost,
        levyTotal: financialsTransmission === null || financialsTransmission === void 0 ? void 0 : financialsTransmission.levyTotal,
        hasError: hasError,
        discount: {
            priceDiscountAmount: financialsTransmission === null || financialsTransmission === void 0 ? void 0 : financialsTransmission.priceDiscountAmount,
            msrpWithDiscount: exteriorColor === null || exteriorColor === void 0 ? void 0 : exteriorColor.msrpWithDiscount,
            sellingPriceWithDiscount: exteriorColor === null || exteriorColor === void 0 ? void 0 : exteriorColor.sellingPriceWithDiscount,
        },
    };
};
export default getModelPePricing;
